<div class="card">
    <div class="card-header">
        <div class="card-icon">
            <ng-content select="[card-icon]"></ng-content>
        </div>
      <ng-content select="[card-header]"></ng-content>
    </div>
  </div>
  